import React from "react";
import PrintButton from "@components/FlowActionButtons/PrintButton";
import type { VendorLicenseTask, VendorLicenseTaskDecision } from "@services/licensing/types";

type LicenseFlowData = {
  id: string;
  status: string;
  task: VendorLicenseTask | null;
  taskDecision?: VendorLicenseTaskDecision | null;
};

interface PrintLicenseProps {
  licenseFlowData?: LicenseFlowData;
  onPrint?: () => void;
}

const LANG_BASE = "licensing";

const PrintLicense: React.FC<PrintLicenseProps> = ({ onPrint }) => {
  const isActionAvailable = true;
  const handlePrint = () => {
    if (onPrint) {
      onPrint();
      return;
    }

    if (typeof window !== "undefined" && typeof window.print === "function") {
      window.print();
      return;
    }
  };

  return (
    <PrintButton
      langBase={LANG_BASE}
      permission="canPrintLicenseApplicationForm"
      isActionAvailable={isActionAvailable}
      onPrint={handlePrint}
    />
  );
};

export default PrintLicense;
